export default function() {
    const linkList = document.querySelectorAll('.c-gridlayout a');

    linkList.forEach(curAnchor => {
        const { innerHTML } = curAnchor;
        if (innerHTML.includes('[[') && innerHTML.includes(']]')) {
            curAnchor.innerHTML = innerHTML.replace(/\[\[|\]\]/g, '');
            curAnchor.classList.add('btn', 'btn-outline-default');
        }
    });
}
